<template>
    <section>
        <!--工具条-->
        <!--<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;margin-bottom:22px;">
            <el-select v-model="SelStatus" filterable placeholder="请选择开票状态" style="width: 110px">
                <el-option label="全部" value="-1"></el-option>
                <el-option label="未开票" value="0"></el-option>
                <el-option label="已开票" value="1"></el-option>
            </el-select>
            <el-select v-model="SelTitleType" filterable placeholder="请选择类型" style="width: 110px">
                <el-option label="全部" value="-1"></el-option>
                <el-option label="企业" value="0"></el-option>
                <el-option label="个人" value="1"></el-option>
            </el-select>
            <el-date-picker v-model="SelStartTime"
                            type="date"
                            placeholder="选择申请开始时间"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            style="width:150px;">
            </el-date-picker>
            <el-date-picker v-model="SelEndTime"
                            type="date"
                            placeholder="选择申请结束时间"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            style="width: 150px;">
            </el-date-picker>
            <el-input v-model="SelUserName" placeholder="会员Id" style="width:200px;margin-left:10px;"></el-input>
            <el-input v-model="searchVal" placeholder="关键字" style="width:200px;margin-left:10px;"></el-input>
            <el-button type="primary" @click="handleSearch()">查询</el-button>
            <!--<el-button type="primary" @click="handleAdd()" v-if="isAdd">新增</el-button>-->
        </el-col>


        <!--列表-->
        <el-table :data="datas"
                  highlight-current-row
                  v-loading="listLoading"
                  @selection-change="selsChange"
                  @current-change="selectCurrentRow"
                  row-key="Id"
                  border
                  lazy
                  style="width: 99%;"
                  ref="table">
            <el-table-column type="index" :index="indexMethod" label="序号" width="50" fixed></el-table-column>

            <el-table-column prop="UserId" label="会员Id" width="120" sortable fixed>
            </el-table-column>
            <el-table-column prop="NickName" label="会员昵称" width="120" sortable fixed>
            </el-table-column>
            <el-table-column label="状态" width="100" sortable fixed>
                <template scope="scope">
                    <span v-if="scope.row.Status==0">未开票</span>
                    <span v-if="scope.row.Status==1">已开票</span>
                </template>
            </el-table-column>
            <el-table-column label="抬头类型" width="120" sortable>
                <template scope="scope">
                    {{scope.row.TitleType==0?'企业':'个人'}}
                </template>
            </el-table-column>
            <el-table-column prop="TitleName" label="抬头名称" sortable width="150"></el-table-column>
            <el-table-column prop="TaxNo" label="税号" width="120" sortable></el-table-column>
            <el-table-column prop="Amount" label="开票金额" sortable width="120"></el-table-column>
            <el-table-column prop="CompanyMobile" label="电话" sortable width="120"></el-table-column>
            <el-table-column prop="AddressDetail" label="地址" sortable width="180"></el-table-column>
            <el-table-column prop="BankName" label="开户银行" width="120" sortable></el-table-column>
            <el-table-column prop="BankAccount" label="银行账号" width="120" sortable></el-table-column>
            <el-table-column prop="Remark" label="申请备注" width="150" sortable></el-table-column>
            <el-table-column prop="Content" label="发票内容" width="150" sortable></el-table-column>
            <el-table-column prop="CreationTime" label="申请日期" :formatter="formatCreateTime" width="150" sortable></el-table-column>

            <el-table-column prop="InvoiceNote" label="开票备注" width="150" sortable></el-table-column>
            <el-table-column prop="InvoiceTime" label="开票时间" :formatter="formatUseTime" width="150" sortable></el-table-column>
            <!--<el-table-column prop="Creatior" label="添加人" width="100" sortable></el-table-column>-->
            <el-table-column label="操作" width="150">
                <template scope="scope">
                    <el-button size="small" @click="handleEdit(scope.$index, scope.row)" v-if="scope.row.Status>0">详情</el-button>
                    <el-button size="small" @click="handleEdit(scope.$index, scope.row)" v-if="scope.row.Status==0">开票</el-button>
                    <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)" v-if="isDelete">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <!--<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>-->
            <el-pagination layout="prev, pager, next"
                           @current-change="handleCurrentChange"
                           :page-size="50"
                           :total="total"
                           style="float:right;"></el-pagination>
        </el-col>
        <!--编辑界面-->
        <el-dialog title="编辑"
                   :visible.sync="editFormVisible"
                   v-model="editFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="editForm" label-width="180px" :rules="editFormRules" ref="editForm">

                <el-collapse v-model="activeNames">
                    <el-collapse-item title="开票申请单信息" name="1">

                        <el-form-item label="用户号Id" prop="UserId">
                            <el-input v-model="editForm.UserId" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="用户号昵称" prop="NickName">
                            <el-input v-model="editForm.NickName" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="抬头类型" prop="TitleType">
                            <el-radio-group v-model="editForm.TitleType" :readonly="true" :disabled="true">
                                <el-radio class="radio" :label="0">企业</el-radio>
                                <el-radio class="radio" :label="1">个人</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="申请金额" prop="Amount">
                            <el-input v-model="editForm.Amount" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="抬头名称" prop="TitleName">
                            <el-input v-model="editForm.TitleName" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="税号" prop="TaxNo">
                            <el-input v-model="editForm.TaxNo" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="开户银行" prop="BankName">
                            <el-input v-model="editForm.BankName" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="银行账户" prop="BankAccount">
                            <el-input v-model="editForm.BankAccount" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="发票内容" prop="Content">
                            <el-input v-model="editForm.Content" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="电话" prop="CompanyMobile">
                            <el-input v-model="editForm.CompanyMobile" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="地址" prop="AddressDetail">
                            <el-input type="textarea" placeholder="地址" v-model="editForm.AddressDetail" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="申请备注" prop="Remark">
                            <el-input type="textarea" placeholder="申请备注" v-model="editForm.Remark" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="状态" prop="Status">
                            <el-radio-group v-model="editForm.Status" :readonly="true" :disabled="true">
                                <el-radio class="radio" :label="0">未开票</el-radio>
                                <el-radio class="radio" :label="1">已开票</el-radio>
                            </el-radio-group>
                        </el-form-item>



                        <el-form-item label="开票时间" prop="InvoiceTime" v-if="showInvoiceInfo">
                            <el-input v-model="editForm.InvoiceTime" auto-complete="off" :readonly="true"></el-input>
                        </el-form-item>
                        <el-form-item label="开票备注" prop="InvoiceNote">
                            <el-input type="textarea" placeholder="开票备注" v-model="editForm.InvoiceNote"></el-input>
                        </el-form-item>
                        <el-form-item :label="index == 0 ? '发票文件' : ''"
                                      v-for="(item, index) in VoucherList"
                                      :key="index">
                            <el-upload action=""
                                       :before-upload="beforeUpload"
                                       :show-file-list="false"
                                       :data="extraData()"
                                       :http-request="(params) => handleHttpRequest(index,params)"
                                        v-if="!showInvoiceInfo">
                                <el-button size="small" type="primary">点击上传</el-button>
                                <span></span>
                            </el-upload>
                            <div v-if="item.VoucherUrl!=null && item.VoucherUrl!=''"><a :href="item.VoucherUrl" target="_blank">发票文件{{index+1}}</a></div>
                            <el-button v-if="index !== 0 && !showInvoiceInfo"
                                       class="mt-2"
                                       type="danger"
                                       @click.prevent="removeVoucher(index)"
                                       style="margin-left:20px;">删除</el-button>
                        </el-form-item>
                        <el-form-item v-if="!showInvoiceInfo">
                            <el-button @click="addVoucher" type="primary">添加发票</el-button>
                        </el-form-item>


                    </el-collapse-item>
                    <el-collapse-item title="订单信息" name="2">
                        <div style="width: 100%;">
                            <div style="width: 100%; ">
                                <ul class="list header eheader">
                                    <li>
                                        <span class="swidth2">订单号码<i style="color:red">*</i></span>
                                        <span class="swidth">申请金额<i style="color:red">*</i></span>
                                        <!--<span>操作</span>-->
                                    </li>
                                </ul>
                                <ul class="list body ebody">
                                    <!-- <FormItem> -->
                                    <li v-for="(item,index) in editForm.UserInvoiceDetails" :key="index">
                                        <span class="swidth2">{{item.OrderId}}</span>
                                        <span class="swidth2">{{item.Amount}}</span>
                                        <!--<span class="swidth"><input @change="ProNum(index)" placeholder="0" type="number" v-model="item.UnitPrice"></span>
                                        <span class="swidth"><input @change="ProNum(index)" placeholder="0" type="number" v-model="item.Quantity"></span>
                                        <span>{{parseFloat(item.UnitPrice*item.Quantity).toFixed(2)}}</span>-->
                                        <!--<span class="swidth"><input @change="ProNum(index)" placeholder="0" type="number" v-model="item.ApplyAmount"></span>-->
                                        <!--<span class="swidth"><input @change="ProNum(index)" placeholder="0" type="number" v-model="item.ApplyAmount"></span>
                                        <span>{{item.PurchaseAmount}}</span>-->
                                        <!--<span>
                                            <strong class="icon" @click="RemeInfo(index)" v-if="editForm.Status==1||editForm.Status==3">删除</strong>
                                        </span>-->
                                    </li>
                                    <!-- </FormItem> -->
                                </ul>
                            </div>
                        </div>
                        <!--<p class="add_btn" @click="AddProduct" v-if="IsShow">增加</p>-->
                        <p class="add_sum">合计：{{editForm.Amount}} </p>
                    </el-collapse-item>



                </el-collapse>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading" v-if="!showInvoiceInfo">提交</el-button>
            </div>
        </el-dialog>


        <!--新增界面-->
        <!--<el-dialog title="新增"
                   :visible.sync="addFormVisible"
                   v-model="addFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="addForm"
                     label-width="100px"
                     :rules="addFormRules"
                     ref="addForm">
                <el-form-item label="名称" prop="Name">
                    <el-input v-model="addForm.Name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="序号" prop="OrderNumber">
                    <el-input-number v-model="addForm.OrderNumber" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="说明" prop="Remark">
                    <el-input type="textarea" placeholder="说明" v-model="addForm.Remark"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="Status">
                    <el-radio-group v-model="addForm.Status">
                        <el-radio class="radio" :label="0">开启</el-radio>
                        <el-radio class="radio" :label="1">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary"
                           @click.native="addSubmit"
                           :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>-->

    </section>
</template>

<script>
    import util from "../../../util/date";
    import { getPageUserInvoice, removeUserInvoice, sendInvoiceFile, getAllInvoiceTitle, uploadArticleFiles } from "../../api/api";
    import { getButtonList } from "../../promissionRouter";
    /* import Toolbar from "../../components/Toolbar2";*/
    /* import global_ from '../../components/Global'//引用全局模块*/

    export default {
        /*  components: { Toolbar },*/
        data() {
            return {
                filters: {
                    name: ""
                },
                searchVal: "",
                SelUserName: "",
                SelCouponId: 0,
                SelStatus: "-1",
                SelTitleType: "-1",
                SelStartTime: "",
                SelEndTime: "",
                buttonList: [],
                datas: [],
                total: 0,
                page: 1,
                activeNames: ['1'],
                allInvoiceTitle: [],
                VoucherList: [],//附件列表
                listLoading: false,
                showInvoiceInfo: false,
                sels: [], //列表选中列
                currentRow: null,
                addDialogFormVisible: false,
                editFormVisible: false, //编辑界面是否显示
                editLoading: false,
                editFormRules: {
                    TitleName: [{ required: true, message: "请输入抬头名称", trigger: "blur" }]
                },
                //编辑界面数据
                editForm: {
                    Id: 0,
                    UserId: 0,
                    InvoiceTitleId: 0,
                    Amount: 0,
                    InvoiceType: "",
                    TitleName: "",
                    TaxNo: "",
                    AddressDetail: "",
                    CompanyMobile: "",
                    BankName: "",
                    BankAccount: "",
                    TitleType: -1,
                    Content: "",
                    Remark: "",
                    Status: 0,
                    InvoiceFile: "",
                    InvoiceNote: ""
                },

                //addFormVisible: false, //新增界面是否显示
                //addLoading: false,
                //addFormRules: {
                //    Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
                //    Remark: [{ required: true, message: "请输入说明", trigger: "blur" }],
                //    Status: [{ required: true, message: "请选择状态", trigger: "blur" }]
                //},
                ////新增界面数据
                //addForm: {
                //    Id: 0,
                //    Name: '',
                //    OrderNumber: 0,
                //    Remark: '',
                //    Status: 0
                //},

                isEdit: false,
                isDelete: false,
                isAdd: false,
                isReply: false,
                isGetAllInvoiceTitle: false,
            };
        },
        filters: {
            filterDate: function (value) {
                return !value || value == ""
                    ? ""
                    : util.formatDate.format(new Date(value), "yyyy-MM-dd");
            }
        },
        methods: {
            indexMethod(index) {
                index = (index + 1) + (this.page - 1) * 20;
                //index = this.total - (this.page - 1) * 20 - index
                return index;
            },
            selectCurrentRow(val) {
                this.currentRow = val;
            },
            callFunction(item) {
                this.filters = {
                    name: item.search
                };
                this[item.Func].apply(this, item);
            },
            formatCreateTime: function (row, column) {
                return !row.CreationTime || row.CreationTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.CreationTime), "yyyy-MM-dd hh:mm");
            },
            formatUseTime: function (row, column) {
                return !row.InvoiceTime || row.InvoiceTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.InvoiceTime), "yyyy-MM-dd hh:mm");
            },
            handleCurrentChange(val) {
                this.page = val;
                this.handleQuery();
            },

            //获取用户列表
            handleGetAllInvoiceTitle(UId) {
                this.allInvoiceTitle = [];
                //let _this = this;
                let para = {
                    UserId: UId
                };
                this.listLoading = true;
                //NProgress.start();
                getAllInvoiceTitle(para).then(res => {
                    this.allInvoiceTitle = res.data.response;
                    this.listLoading = false;

                    //NProgress.done();
                });
            },
            handleSearch() {
                this.page = 1;
                this.handleQuery();
            },
            //获取用户列表
            handleQuery() {
                var userId = "0";
                if (this.SelUserName == null || this.SelUserName == "" || isNaN(this.SelUserName) || Number(this.SelUserName) < 0) {
                    userId = "0";
                } else {
                    userId = this.SelUserName;
                }
                //let _this = this;
                let para = {
                    page: this.page,
                    key: this.searchVal,
                    UserId: userId,
                    Status: this.SelStatus,
                    StartTime: this.SelStartTime,
                    EndTime: this.SelEndTime,
                    TitleType: this.SelTitleType
                };
                this.listLoading = true;
                //NProgress.start();
                getPageUserInvoice(para).then(res => {
                    this.total = res.data.response.dataCount;
                    this.datas = res.data.response.data;
                    this.listLoading = false;

                    console.log("total=" + this.total);

                    //NProgress.done();
                });
            },
            ////删除
            handleDel(index, cRow) {
                this.currentRow = cRow;
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要编辑的一行数据！",
                        type: "error"
                    });

                    return;
                }
                this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        this.listLoading = true;
                        //NProgress.start();
                        let para = { id: row.Id };
                        removeUserInvoice(para).then(res => {
                            if (util.isEmt.format(res)) {
                                this.listLoading = false;
                                return;
                            }
                            this.listLoading = false;
                            //NProgress.done();
                            if (res.data.success) {
                                this.$message({
                                    message: "删除成功",
                                    type: "success"
                                });
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error"
                                });
                            }

                            this.handleQuery();
                        });
                    })
                    .catch(() => { });
            },
            //显示编辑界面
            handleEdit(index, cRow) {

                this.currentRow = cRow;
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要编辑的一行数据！",
                        type: "error"
                    });
                    return;
                }
                //this.handleGetAllInvoiceTitle(row.UserId);

                this.showInvoiceInfo = false;
                if (row.Status > 0) {
                    this.showInvoiceInfo = true;
                }
                this.VoucherList = [];
                if (row.InvoiceFile != null && row.InvoiceFile != "") {
                    var RVoucher = String(row.InvoiceFile);
                    var vouchers = RVoucher.split(",");
                    //console.log('bbb');
                    for (var i = 0; i < vouchers.length; i++) {
                        var inNo = vouchers[i].toString();
                        if (inNo != null && inNo != "") {
                            this.VoucherList.push({
                                VoucherUrl: inNo
                            });
                        }
                    }
                }

                let that = this;

                this.editForm = {};
                that.editLoading = true;
                that.editFormVisible = true;

                that.editForm = Object.assign({}, row);

                that.editLoading = false;

            },
            ////显示新增界面
            //handleAdd() {
            //    this.addFormVisible = true;
            //    this.addLoading = true;
            //    this.addForm = {
            //        Name: '',
            //        OrderNumber: 0,
            //        Remark: '',
            //        Status: 0
            //    };
            //    this.addLoading = false;
            //},
            //编辑
            editSubmit: function () {
                this.$refs.editForm.validate(valid => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.editLoading = true;
                            //NProgress.start();

                            let para = Object.assign({}, this.editForm);
                            if (para.TitleName == null || para.TitleName == "") {
                                this.$message({
                                    message: "抬头名称不能为空！",
                                    type: "error"
                                });
                                this.editLoading = false;
                                return;
                            }
                            if (this.VoucherList == null || this.VoucherList.length <= 0) {
                                this.$message({
                                    message: "请上传发票文件！",
                                    type: "error"
                                });
                                this.editLoading = false;
                                return;
                            }
                            para.InvoiceFile = this.VoucherList.map(item => { return item.VoucherUrl }).toString();
                            sendInvoiceFile(para).then(res => {
                                if (util.isEmt.format(res)) {
                                    this.editLoading = false;
                                    return;
                                }

                                if (res.data.success) {
                                    this.editLoading = false;
                                    //NProgress.done();
                                    this.$message({
                                        message: res.data.msg,
                                        type: "success"
                                    });
                                    this.$refs["editForm"].resetFields();
                                    this.editFormVisible = false;
                                    this.handleQuery();
                                } else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error"
                                    });
                                    this.editLoading = false;
                                }
                            });
                        });
                    }
                });
            },
            ////新增
            //addSubmit: function () {
            //    let _this = this;
            //    this.$refs.addForm.validate(valid => {
            //        if (valid) {
            //            this.$confirm("确认提交吗？", "提示", {}).then(() => {
            //                this.addLoading = true;
            //                //NProgress.start();
            //                let para = Object.assign({}, this.addForm);


            //                if (para.Name == null || para.Name == "") {
            //                    this.$message({
            //                        message: "名称不能为空！",
            //                        type: "error"
            //                    });
            //                    this.addLoading = false;
            //                    return;
            //                }

            //                if (para.Remark == null || para.Remark == "") {
            //                    this.$message({
            //                        message: "说明不能为空！",
            //                        type: "error"
            //                    });
            //                    this.addLoading = false;
            //                    return;
            //                }
            //                addGoodsName(para).then(res => {
            //                    if (util.isEmt.format(res)) {
            //                        this.addLoading = false;
            //                        return;
            //                    }
            //                    if (res.data.success) {
            //                        this.addLoading = false;
            //                        //NProgress.done();
            //                        this.$message({
            //                            message: res.data.msg,
            //                            type: "success"
            //                        });
            //                        this.$refs["addForm"].resetFields();
            //                        this.addFormVisible = false;
            //                        this.isCarNoShow = true;
            //                        this.handleQuery();
            //                    } else {
            //                        this.$message({
            //                            message: res.data.msg,
            //                            type: "error"
            //                        });
            //                        this.addLoading = false;
            //                    }

            //                });
            //            });
            //        }
            //    });
            //},
            selsChange: function (sels) {
                this.sels = sels;
            },
            ////批量删除
            //batchRemove: function () {
            //    this.$message({
            //        message: "该功能未开放",
            //        type: "warning"
            //    });
            //},
            //getButtonList2(routers) {
            //    let _this = this;
            //    routers.forEach(element => {
            //        let path = this.$route.path.toLowerCase();
            //        if (element.path && element.path.toLowerCase() == path) {
            //            _this.buttonList = element.children;
            //            return;
            //        } else if (element.children) {
            //            _this.getButtonList(element.children);
            //        }
            //    });
            //}
            //上传文件start

            extraData() {
                return {
                    //"name": this.form.name,
                    //"version": this.form.version,
                    //"type": this.form.type
                }
            },
            //添加附件
            addVoucher() {
                this.VoucherList.push({
                    VoucherUrl: ''
                });
            },
            // 删除附件
            removeVoucher(index) {
                console.log("index=" + index);
                if (index >= 0) {
                    this.VoucherList.splice(index);
                }
            },
            handleHttpRequest(index, event) {
                var fileDatas = event.file;
                var para = new FormData();
                para.append("file", fileDatas);
                this.editLoading = true;
                uploadArticleFiles(para).then(res => {
                    if (util.isEmt.format(res)) {
                        this.editLoading = false;
                        return;
                    }
                    if (res.data.success) {
                        this.editLoading = false;
                        //NProgress.done();
                        this.$message({
                            message: res.data.msg,
                            type: "success"
                        });

                        this.VoucherList.splice(index, 1, { VoucherUrl: window.server.PictureDemain + res.data.response }); // 更新对应索引的文件
                        //this.IsShowVoucher = true;
                        //this.EditVoucher = res.data.response;
                        //this.EditVoucherUrl = res.data.response;

                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "error"
                        });
                        this.editLoading = false;
                    }
                })
            },
            beforeUpload(file) {
                if (file.size >= 104857600) {
                    this.$message({
                        message: "订单合同不能大于100M",
                        type: "warning"
                    });
                    this.addLoading = false;
                    return false;
                }
                return true;
            },

            //上传文件end
        },
        mounted() {

            var queryUserId = this.$route.query.UserId;//获取从会员管理查询点击定位跳转过来的会员Id
            if (queryUserId && queryUserId != null && queryUserId != "" && !isNaN(queryUserId) && Number(queryUserId) > 0) {
                this.SelUserName = queryUserId.toString();
            }
            this.handleQuery();

            let routers = window.localStorage.router
                ? JSON.parse(window.localStorage.router)
                : [];
            //第一种写法，每个页面都需要写方法，但是可以做特性化处理
            // this.getButtonList(routers);

            //第二种写法，封装到 permissionRouter.js 中
            this.buttonList = getButtonList(this.$route.path, routers);

            this.buttonList.forEach(item => {
                if (item.Func == "handleEdit") {
                    this.isEdit = true;
                }
                else if (item.Func == "handleDel") {
                    this.isDelete = true;
                }
                else if (item.Func == "handleAdd") {
                    this.isAdd = true;
                }
                else if (item.Func == "handleSendFile") {
                    this.isReply = true;
                }
                else if (item.Func == "handleGetAllInvoiceTitle") {
                    this.isGetAllInvoiceTitle = true;
                }
                //
            });
        }
    };
</script>


<style>
    .el-table__fixed {
        height: auto !important;
        bottom: 17px !important;
        z-index: 999;
    }

    .editFormStyle {
        width: 80%;
    }
</style>


<style scoped>


    .ivu-btn {
        margin-bottom: 0;
    }

    .v-selectpage {
        width: 130px;
    }

    .list {
        border-top: 1px solid #e8eaec;
        border-left: 1px solid #e8eaec;
    }

        .list .header {
            background-color: #f8f8f9;
        }

        .list .body {
            border-top: none;
        }

    .ivu-form-item {
        margin-bottom: 0;
    }

    li {
        display: flex;
        justify-content: start;
        justify-items: center;
    }

        li span {
            width: 120px;
            text-align: center;
            border-right: 1px solid #e8eaec;
            border-bottom: 1px solid #e8eaec;
            padding: 5px 0;
            min-height: 26px;
            line-height: 26px;
        }

    .swidth {
        width: 45% !important;
    }

    .swidth2 {
        width: 55%!important;
    }


            li span:last-child {
                width: 11%;
            }

                li span:last-child .icon {
                    display: inline-block;
                    height: 26px;
                    line-height: 26px;
                    text-align: center;
                    background-color: red;
                    color: #fff;
                    border-radius: 4px;
                    padding: 0 15px;
                    font-size: 14px;
                }

    /* li span:first-child {
                flex: 1;
            }*/

    .list span input {
        width: 90%;
        height: 26px;
        line-height: 26px;
        /*border: none;*/
        text-align: center;
    }

    .list span select {
        width: 90%;
        height: 26px;
        line-height: 26px;
        border: none;
        text-align: center;
    }

    /* .list span input:focus {
        outline: none;
    }*/

    /* .list span input::-webkit-outer-spin-button,
    .list span input::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
        margin: 0;
    }*/

    .add_btn {
        background-color: #2d8cf0;
        color: #fff;
        text-align: center;
        line-height: 36px;
    }

    .add_sum {
        text-align: right;
        line-height: 40px;
    }

    .GarageChatCss {
        text-align: left;
    }

    .GarageChatCss2 {
        text-align: left;
        color: black;
    }

    .SupplierChatCss {
        text-align: right;
    }

    .SupplierChatCss2 {
        text-align: right;
        color: green;
    }


    .record {
        margin: 10px;
        width: 100%;
        height: 100%;
        display: flex;
        /* justify-content: center;
        align-items: center;*/
        flex-wrap: wrap;
    }

    .recorderBtn {
        width: 150px;
        height: 40px;
        background-color: #409eff;
        color: #fff;
        border: none;
        border-radius: 5px;
        font-size: 16px;
    }

    .record .isClicked {
        background-color: royalblue;
    }
</style>